/**
 * Le 20 regioni italiane, per il campo `regione` dell'anagrafica socio.
 *
 * Il territorio del socio era catturato dal solo comune, digitato a mano: senza
 * la regione non si poteva raggruppare la base soci su base territoriale né
 * compilare i tracciati GSE che la richiedono separata (INB-113). Elenco chiuso
 * perché le regioni sono un insieme fisso e noto.
 */
export const ITALIAN_REGIONS = [
	'Abruzzo',
	'Basilicata',
	'Calabria',
	'Campania',
	'Emilia-Romagna',
	'Friuli-Venezia Giulia',
	'Lazio',
	'Liguria',
	'Lombardia',
	'Marche',
	'Molise',
	'Piemonte',
	'Puglia',
	'Sardegna',
	'Sicilia',
	'Toscana',
	'Trentino-Alto Adige',
	'Umbria',
	"Valle d'Aosta",
	'Veneto',
] as const;

export type ItalianRegion = (typeof ITALIAN_REGIONS)[number];

/** Le regioni nel formato atteso dalle props `options` dei menu a tendina. */
export const REGION_SELECT_OPTIONS: { value: string; label: string }[] = ITALIAN_REGIONS.map(
	(r) => ({ value: r, label: r }),
);
